import script from "./BaseMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./BaseMultiSelect.vue?vue&type=style&index=0&id=076c2e4e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076c2e4e"]])

export default __exports__